import React from 'react';
import { Hero } from './components/Hero';
import { SalesLetter } from './components/SalesLetter';
import { TomosSection } from './components/TomosSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { CostSection } from './components/CostSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-ink-950 font-sans" data-id="element-0" data-mp="2wjql9i09eorx">
      <Hero data-id="element-1" data-mp="2wi5n7ieqknpb" />
      <main data-id="element-2" data-mp="28ufnm9e7hai0">
        <SalesLetter data-id="element-3" data-mp="28tw6guwdqq51" />
        <TomosSection data-id="element-4" data-mp="28te2td7e19n3" />
        <BenefitsSection data-id="element-5" data-mp="28sur4e8bzhhi" />
        <BonosSection data-id="element-6" data-mp="28s2z1ddy01vz" />
        <PricingSection data-id="element-7" data-mp="23vune9yyeqtk" />
        <CostSection data-id="element-8" data-mp="23u9qidp62vsj" />
        <TestimonialsSection data-id="element-9" data-mp="23v2rsz5cwt3a" />
        <GuaranteeSection data-id="element-10" data-mp="3ijxo6nd1puib" />
        <FaqSection data-id="element-11" data-mp="3ikqyfyb7r257" />
        <FinalCta data-id="element-12" data-mp="3ij65gd4jrr9g" />
      </main>
      <Footer data-id="element-13" data-mp="3ii4t85bsoyq5" />
    </div>;
}